import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSlideIn20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconArrowSlideIn20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M12.352 16.3a6.27 6.27 0 0 1-3.328-1.155l1.022-1.12a4.809 4.809 0 1 0 2.63-8.832 4.8 4.8 0 0 0-3.041 1.085L8.518 5.26a6.28 6.28 0 0 1 4.158-1.568L13 3.7a6.31 6.31 0 0 1 5.976 5.976l.007.324a6.31 6.31 0 0 1-6.308 6.309zM7.41 12.68a.75.75 0 0 1-1.06-1.06l.854-.854H1.846a.75.75 0 0 1 0-1.5h5.368L6.35 8.4a.75.75 0 0 1 1.06-1.06l2.67 2.67-.559.558z"
            />
        </svg>
    );
}
export default memo(IconArrowSlideIn20);
